/**
 * Tiny fire-and-forget analytics helper.
 *
 * Usage:
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent("premium_upgrade_clicked", "whats_new", { plan: "yearly" });
 *
 * - Never blocks the UI (catches errors silently)
 * - Auto-attaches the auth token if present
 * - Can be safely called from components
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackEvent(event, source = null, metadata = null) {
  try {
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    // Fire and forget — no await
    axios
      .post(
        `${API}/analytics/event`,
        { event, source, metadata },
        { headers, withCredentials: true, timeout: 4000 }
      )
      .catch(() => {
        /* silent — analytics must never disturb user flow */
      });
  } catch {
    /* silent */
  }
}
